export const WELCOME = 0;
export const NAME = 1;
export const ADMINISTRATORS = 2;
export const FINALITY = 3;
export const CREDIT = 4;
export const PHONE = 5;
export const RESULTS = 6;
export const TYPE_INTO = 7;
// specifics
export const SERVOPA_OPTIONS = 8;
export const SERVOPA_MPAR = 9;